import React from 'react';
import Icon from '../../../components/AppIcon';

const UpdatesSection = () => {
  const updates = [
    {
      id: 1,
      date: "January 15, 2026",
      category: "FIFA Regulation",
      title: "Updated Work Permit Requirements for UK Transfers",
      description: "The FA has revised the Governing Body Endorsement points system for international players. New criteria emphasize club competition performance and domestic league quality.",
      impact: "High",
      icon: "AlertCircle",
      color: "error"
    },
    {
      id: 2,
      date: "December 20, 2025",
      category: "UEFA Compliance",
      title: "Financial Fair Play 2.0 Implementation",
      description: "UEFA's revised Financial Sustainability Regulations come into effect, introducing squad cost ratio limits and enhanced monitoring mechanisms.",
      impact: "High",
      icon: "TrendingUp",
      color: "warning"
    },
    {
      id: 3,
      date: "November 10, 2025",
      category: "FIFA TMS",
      title: "Enhanced Transfer Matching System Features",
      description: "FIFA introduces real-time compliance checking and automated solidarity payment calculations in the TMS platform.",
      impact: "Medium",
      icon: "Database",
      color: "primary"
    },
    {
      id: 4,
      date: "October 5, 2025",
      category: "Youth Protection",
      title: "Strengthened Minor Transfer Regulations",
      description: "FIFA implements stricter documentation requirements for international transfers of players under 18, including enhanced welfare monitoring.",
      impact: "High",
      icon: "Shield",
      color: "success"
    },
    {
      id: 5,
      date: "September 18, 2025",
      category: "Data Protection",
      title: "GDPR Compliance Updates for Player Data",
      description: "New guidelines for handling player personal data in transfer processes, including consent requirements and data retention policies.",
      impact: "Medium",
      icon: "Lock",
      color: "secondary"
    },
    {
      id: 6,
      date: "August 22, 2025",
      category: "CAF Regulation",
      title: "African Player Transfer Window Alignment",
      description: "CAF announces harmonization of transfer windows across African leagues to facilitate smoother international transfers.",
      impact: "Medium",
      icon: "Globe",
      color: "accent"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full mb-4 md:mb-6">
            <Icon name="Bell" size={20} color="var(--color-primary)" />
            <span className="text-sm md:text-base font-medium text-primary">Latest Updates</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4 md:mb-6 font-headline">
            Regulatory Updates & Changes
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-3xl mx-auto">
            Stay informed about the latest changes in football transfer regulations, compliance requirements, and industry standards.
          </p>
        </div>

        <div className="space-y-6 md:space-y-8">
          {updates?.map((update) => (
            <div
              key={update?.id}
              className="bg-card rounded-xl border border-border p-6 md:p-8 hover:shadow-lg transition-all duration-300"
            >
              <div className="flex flex-col md:flex-row gap-6">
                <div className={`w-16 h-16 md:w-20 md:h-20 bg-${update?.color}/10 rounded-lg flex items-center justify-center flex-shrink-0`}>
                  <Icon name={update?.icon} size={32} color={`var(--color-${update?.color})`} />
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-3 mb-3">
                    <span className="text-xs md:text-sm text-muted-foreground flex items-center gap-1">
                      <Icon name="Calendar" size={14} />
                      {update?.date}
                    </span>
                    <span className="px-3 py-1 bg-primary/10 text-primary text-xs md:text-sm font-medium rounded-full">
                      {update?.category}
                    </span>
                    <span className={`px-3 py-1 bg-${update?.color}/10 text-${update?.color} text-xs md:text-sm font-medium rounded-full`}>
                      {update?.impact} Impact
                    </span>
                  </div>

                  <h3 className="text-lg md:text-xl lg:text-2xl font-bold text-foreground mb-3 font-headline">
                    {update?.title}
                  </h3>

                  <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                    {update?.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 lg:mt-16 bg-gradient-to-br from-primary/5 to-secondary/5 rounded-xl p-6 md:p-8 lg:p-10 border border-primary/20">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name="Mail" size={32} color="var(--color-primary)" />
            </div>
            <div className="flex-1">
              <h3 className="text-xl md:text-2xl font-bold text-foreground mb-3 font-headline">
                Subscribe to Compliance Updates
              </h3>
              <p className="text-sm md:text-base text-muted-foreground mb-6">
                Receive instant notifications about regulatory changes, compliance updates, and industry developments directly to your inbox.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  placeholder="Enter your email address"
                  className="flex-1 px-4 py-3 bg-card border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary text-sm md:text-base"
                />
                <button className="px-6 py-3 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors duration-300 flex items-center justify-center gap-2 whitespace-nowrap">
                  <Icon name="Send" size={20} />
                  Subscribe Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpdatesSection;